// extracted by mini-css-extract-plugin
export default {"entry-card":"AvatarSetupModal__entry-card__BTlLT","entryCard":"AvatarSetupModal__entry-card__BTlLT"};